
import { defineComponent, onMounted, reactive, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup () {
    const route = useRoute()
    const internalInstance = getCurrentInstance()
    const message = reactive({
      msg: '',
      err: false
    })
    onMounted(() => {
      if (Object.keys(route.query).length) {
        const apiPath = internalInstance?.appContext.config.globalProperties.api_path
        fetch(apiPath + 'ajax/confmail.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: route.query.id, token: route.query.token })
        }).then(response => response.json())
          .then(json => {
            // console.log(json);
            if (json.result === 'failure') {
              throw new Error(json.error)
            }
            message.err = false
          })
          .catch(error => {
            console.error(error)
            message.err = true
            message.msg = error.message
          })
      }
    })

    return {
      message
    }
  }
})
